import { Component, OnInit } from '@angular/core';
import { StaffService } from 'src/app/services/Staff/staff.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'

@Component({
  selector: 'app-staff-id-card',
  templateUrl: './staff-id-card.component.html',
  styleUrls: ['./staff-id-card.component.css']
})
export class StaffIdCardComponent implements OnInit {
  dropdownSettings: any = {};
  selectedItems: any = [];
  StudentExist: any;
  MessageChild: any;
  SubmittedPersonnel: any;
  SubmittedEmployee: any;
  SubmittedDependent: boolean = false;
  SubmittedChild: boolean = false;
  LeavinDateMsg: any;
  FilePath: any;
  SelectedFileForUpload: any;
  SelectPhotoforUpload: any;
  Docmsg: any;
  MesgAlert: any;
  BankList: any;
  Designation: any;
  State: any;
  StaffDocumentList: any;
  ListDepartment: any;
  ListMarital: any;
  SchoolLocationList: any;
  IDCardTypeList: any;
  EmployeeCategoryList: any;
  EmployeeTypeList: any;
  ReligionList: any;
  ReportingManagerList: any;
  QualificationList: any;
  StateList: any;
  City: any;
  CountryList: any;
  BloodGroupList: any;
  RelationShipList: any;
  NationalityList: any;
  ListStaff: any;
  StaffDependentList: any;
  StaffChildList: any;
  AddChildList: any;
  DocsList: any;

  constructor(private staffservice: StaffService, public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,
    private lookupService: LookupService) { }


  searchStaffModel = {
    FirstName: '',
    LastName: '',
    EmployeeCategoryID: 0,
    EmploymentStatus: "0",
    EmployeeTypeID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    StaffIdentity: '',
    IsActive: false,
    JoiningFromDate: '',
    JoiningToDate: '',
    CurrentIndex: 0,
    PageSize: 10
  }

  SearchAllstaff() {
    this.spinnerService.show();
    this.ListStaff = [];
    this.searchStaffModel.CurrentIndex = this.currentPage;
    this.searchStaffModel.PageSize = this.pageSize;
    this.searchStaffModel.JoiningFromDate = this.searchStaffModel.JoiningFromDate != null && this.searchStaffModel.JoiningFromDate != '' ? moment(this.searchStaffModel.JoiningFromDate).format('DD-MMM-YYYY') : '';
    this.searchStaffModel.JoiningToDate = this.searchStaffModel.JoiningToDate != null && this.searchStaffModel.JoiningToDate != '' ? moment(this.searchStaffModel.JoiningToDate).format('DD-MMM-YYYY') : '';
    this.staffservice.SearchAllstaff(JSON.stringify(this.searchStaffModel)).subscribe((response: any) => {
      this.ListStaff = response.ListStaff;
      this.recordCount = 0;
      this.spinnerService.hide();
      if (response.ListStaff != null && response.ListStaff.length > 0) {
        this.recordCount = response.ListStaff[0].RecordCount;
      }
      this.numberOfPages();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  StaffProfileModel =
    {
      StaffID: 0,
      FirstName: '',
      MiddleName: '',
      LastName: '',
      Gender: '0',
      DOB: '',
      DependentDOB: '',
      BloodGroupID: 0,
      Phone: '',
      PrimaryDepartmentID: 0,
      Mobile: '',
      PresentAddress: '',
      PresentCityID: 0,
      SchoolLocationID: 0,
      PresentZipCode: '',
      IsPresentAddress: false,
      Permanentaddress: '',
      IsActive: true,
      PresentStateID: 0,
      PermanentStateID: 0,
      PermanentCityID: 0,
      PermanentZipCode: '',
      PresentCountryID: 0,
      PermanentCountryID: 0,
      DependentName: '',
      DocumentID: 0,
      StaffIdentity: '',
      MaritalStatusID: 0,
      DateOfJoining: '',
      IDCardNo: '',
      DateOfLeaving: '',
      HouseID: 0,
      DesignationID: 0,
      YearsOfService: '',
      BankName: '',
      AccountNumber: '',
      PANCard: '',
      PFNumber: '',
      RelationshipID: 0,
      PermanentState: '',
      PermanentCity: '',
      FatherName: '',
      MotherName: '',
      SpouseName: '',
      NationalityID: 0,
      ReligionID: 0,
      IdentificationMarks: '',
      EmergencyContactNo: '',
      ContactPerson: '',
      QualificationID: 0,
      QualificationIDs: '',
      ReportingManagerID: 0,
      EmployeeTypeID: 0,
      IDCardTypeID: 0,
      EmployeeCategoryID: 0,
      EmploymentStatus: '0',
      QualificationArray: [],
      StaffPhotoPath: '',
      EmailID: '',
      BankID: 0,
      BankBranch: '',
      IFSCCode: '',
      StudentNo: '',
      StudentID: 0,
      StaffStudentRelationID: 0,
      StaffDependentID: 0,
    };

  // Clear Model
  Clear() {
    this.Action = 'Add';
    this.StaffProfileModel.StaffID = 0,
      this.StaffProfileModel.FirstName = '',
      this.StaffProfileModel.MiddleName = '',
      this.StaffProfileModel.LastName = '',
      this.StaffProfileModel.Gender = "0",
      this.StaffProfileModel.DOB = '',
      this.StaffProfileModel.EmailID = '',
      this.StaffProfileModel.DependentDOB = '',
      this.StaffProfileModel.BloodGroupID = 0,
      this.StaffProfileModel.Phone = '',
      this.StaffProfileModel.Mobile = '',
      this.StaffProfileModel.PresentAddress = '',
      this.StaffProfileModel.BloodGroupID = 0,
      this.StaffProfileModel.PresentCityID = 0,
      this.StaffProfileModel.PresentZipCode = '',
      this.StaffProfileModel.IsPresentAddress = false,
      this.StaffProfileModel.Permanentaddress = '',
      this.StaffProfileModel.IsActive = false,
      this.StaffProfileModel.PresentStateID = 0,
      this.StaffProfileModel.PermanentStateID = 0,
      this.StaffProfileModel.PermanentCityID = 0,
      this.StaffProfileModel.PermanentZipCode = '',
      this.StaffProfileModel.PresentCountryID = 0,
      this.StaffProfileModel.PermanentCountryID = 0,
      this.StaffProfileModel.DependentName = '',
      this.StaffProfileModel.PrimaryDepartmentID = 0,
      this.StaffProfileModel.DocumentID = 0,
      this.StaffProfileModel.StaffIdentity = '',
      this.StaffProfileModel.MaritalStatusID = 0,
      this.StaffProfileModel.DateOfJoining = '',
      this.StaffProfileModel.DateOfLeaving = '',
      this.StaffProfileModel.DesignationID = 0,
      this.StaffProfileModel.YearsOfService = '',
      this.StaffProfileModel.BankName = '',
      this.StaffProfileModel.AccountNumber = '',
      this.StaffProfileModel.PANCard = '',
      this.StaffProfileModel.PFNumber = '',
      this.StaffProfileModel.DOB = '',
      this.StaffProfileModel.RelationshipID = 0,
      this.StaffProfileModel.PermanentState = '',
      this.StaffProfileModel.PermanentCity = '',
      this.StaffProfileModel.FatherName = '',
      this.StaffProfileModel.MotherName = '',
      this.StaffProfileModel.SpouseName = '',
      this.StaffProfileModel.NationalityID = 0,
      this.StaffProfileModel.ReligionID = 0,
      this.StaffProfileModel.IdentificationMarks = '',
      this.StaffProfileModel.EmergencyContactNo = '',
      this.StaffProfileModel.IDCardNo = '',
      this.StaffProfileModel.ContactPerson = '',
      this.StaffProfileModel.QualificationArray = [],
      this.StaffProfileModel.ReportingManagerID = 0,
      this.StaffProfileModel.EmployeeTypeID = 0,
      this.StaffProfileModel.EmployeeCategoryID = 0
    this.StaffProfileModel.StudentID = 0;
    this.StaffProfileModel.StaffStudentRelationID = 0;
    this.StaffProfileModel.StudentNo = '';
    this.StaffProfileModel.StaffDependentID = 0;
    this.StudentExist = '';
    this.MessageChild = '';
    this.SubmittedPersonnel = false;
    this.SubmittedEmployee = false;
    this.DocsList = [];

  }

  // Edit Staff Details

  EditStaffDetails(obj) {
    this.DocsList = [];
    this.StaffProfileModel.StaffID = obj.StaffID;
    this.GetReportingManager();
    this.selectedItems = [];

    var QualificationIDs = obj.QualificationIDs != null ? obj.QualificationIDs.split(',') : '';
    if (this.QualificationList != null) {
      for (var i = 0; i < this.QualificationList.length; i++) {
        for (var j = 0; j < QualificationIDs.length; j++) {
          if (QualificationIDs[j] == this.QualificationList[i].ItemId) {
            let item = {
              ItemId: this.QualificationList[i].ItemId,
              ItemName: this.QualificationList[i].ItemName
            }
            this.selectedItems.push(item)
            break;
          }
        }
      }
    }

    this.StaffProfileModel.QualificationArray = this.selectedItems;
    this.StaffProfileModel.StaffPhotoPath = obj.StaffPhotoPath;
    this.StaffProfileModel.SchoolLocationID = obj.SchoolLocationID;
    this.StaffProfileModel.FirstName = obj.FirstName;
    this.StaffProfileModel.EmploymentStatus = obj.EmploymentStatus;
    this.StaffProfileModel.MiddleName = obj.MiddleName;
    this.StaffProfileModel.LastName = obj.LastName;
    this.StaffProfileModel.Gender = obj.Gender.trim().toString();
    this.StaffProfileModel.BloodGroupID = obj.BloodGroupID;
    this.StaffProfileModel.EmailID = obj.EmailID;
    this.StaffProfileModel.SchoolLocationID = obj.SchoolLocationID;
    this.StaffProfileModel.Phone = obj.Phone;
    this.StaffProfileModel.Mobile = obj.Mobile;
    this.StaffProfileModel.BankID = obj.BankID;
    this.StaffProfileModel.BankBranch = obj.BankBranch;
    this.StaffProfileModel.IFSCCode = obj.IFSCCode;
    this.StaffProfileModel.PresentCountryID = obj.PresentCountryID;
    this.StaffProfileModel.EmployeeCategoryID = obj.EmployeeCategoryID;
    this.GetPresentState();
    this.StaffProfileModel.PresentStateID = obj.PresentStateID;
    this.GetCityName();
    this.StaffProfileModel.PresentCityID = obj.PresentCityID;
    this.StaffProfileModel.PresentAddress = obj.PresentAddress;
    this.StaffProfileModel.PresentZipCode = obj.PresentZipCode;
    this.StaffProfileModel.IsPresentAddress = obj.IsPresentAddress;
    this.StaffProfileModel.PermanentCountryID = obj.PermanentCountryID;
    this.StaffProfileModel.Permanentaddress = obj.Permanentaddress;
    this.StaffProfileModel.PermanentZipCode = obj.PermanentZipCode;
    this.StaffProfileModel.PermanentState = obj.PermanentState;
    this.StaffProfileModel.PermanentCity = obj.PermanentCity;
    this.StaffProfileModel.FatherName = obj.FatherName;
    this.StaffProfileModel.MotherName = obj.MotherName;
    this.StaffProfileModel.SpouseName = obj.SpouseName;
    this.StaffProfileModel.IdentificationMarks = obj.IdentificationMarks;
    this.StaffProfileModel.NationalityID = obj.NationalityID;
    this.StaffProfileModel.ReligionID = obj.ReligionID;
    this.StaffProfileModel.EmergencyContactNo = obj.EmergencyContactNo;
    this.StaffProfileModel.ContactPerson = obj.ContactPerson;
    this.StaffProfileModel.PrimaryDepartmentID = obj.PrimaryDepartmentID;
    this.StaffProfileModel.StaffIdentity = obj.StaffIdentity;
    this.StaffProfileModel.ReportingManagerID = obj.ReportingManagerID;
    this.StaffProfileModel.EmployeeTypeID = obj.EmployeeTypeID;
    this.StaffProfileModel.MaritalStatusID = obj.MaritalStatusID;
    this.StaffProfileModel.DateOfLeaving = obj.DateOfLeaving != null ? moment(obj.DateOfLeaving).format('DD-MMM-YYYY') : '';
    this.StaffProfileModel.DesignationID = obj.DesignationID;
    this.StaffProfileModel.YearsOfService = obj.YearsOfService;
    this.StaffProfileModel.BankName = obj.BankName;
    this.StaffProfileModel.AccountNumber = obj.AccountNumber;
    this.StaffProfileModel.PANCard = obj.PANCard;
    this.StaffProfileModel.DateOfJoining = obj.DateOfJoining != null ? moment(obj.DateOfJoining).format('DD-MMM-YYYY') : '';
    this.StaffProfileModel.DOB = obj.DOB != null ? moment(obj.DOB).format('DD-MMM-YYYY') : '';
    this.StaffProfileModel.DependentName = obj.DependentName;
    this.StaffProfileModel.IsActive = obj.IsActive;
    this.GetStaffDependentDetails();
    this.GetStaffChildDetails();
    this.GetStaffDocumentPhoto();
    this.GetStaffDocument();
    this.SubmittedDependent = false;
    this.SubmittedChild = false;
    this.StaffProfileModel.StudentNo = '';
    this.Action = 'Edit'

  }

  ValidateDropdownStaffDetails() {
    return this.StaffProfileModel.Gender == "0" || this.StaffProfileModel.EmployeeCategoryID == 0;

  };

  SaveStaffDetails(valid) {
    this.SubmittedEmployee = true;
    if (valid && !this.ValidateDropdownStaffDetails()) {
      this.spinnerService.show();
      this.StaffProfileModel.DOB = this.StaffProfileModel.DOB != null && this.StaffProfileModel.DOB != '' ? moment(this.StaffProfileModel.DOB).format('DD-MMM-YYYY') : '';
     
      this.staffservice.SaveStaffDetails(JSON.stringify(this.StaffProfileModel), '', '', '', '', 'StaffDetails').subscribe((response: any) => {
        this.SubmittedEmployee = false;
        this.StaffProfileModel.StaffID = response.StaffID
        this.StaffProfileModel.StaffIdentity = response.StaffIdentity
        this.globalHelper.CheckActionStatus(response);
        this.spinnerService.hide();
        this.SearchAllstaff();
      });
    }
  };

  IsSamePresentAddress() {
    if (this.StaffProfileModel.IsPresentAddress) {
      this.StaffProfileModel.PermanentCountryID = this.StaffProfileModel.PresentCountryID;
      if (this.StateList != null) {
        for (var i = 0; i < this.StateList.length; i++) {
          if (this.StateList[i].ItemId == this.StaffProfileModel.PresentStateID) {
            this.StaffProfileModel.PermanentState = this.StateList[i].ItemName;
            break;
          }
        }
      }
      if (this.City != null) {
        for (var i = 0; i < this.City.length; i++) {
          if (this.City[i].ItemId == this.StaffProfileModel.PresentCityID) {
            this.StaffProfileModel.PermanentCity = this.City[i].ItemName;
            break;
          }
        }
      }
      this.StaffProfileModel.Permanentaddress = this.StaffProfileModel.PresentAddress;
      this.StaffProfileModel.PermanentZipCode = this.StaffProfileModel.PresentZipCode;
    }
  }


  // Personal Details

  ValidateDropdownPersonalDetails() {
    return this.StaffProfileModel.PrimaryDepartmentID == 0 || this.StaffProfileModel.EmployeeTypeID == 0;

  };

  SavePersonalDetails(valid) {
    this.LeavinDateMsg = '';
    var QualifivationID = '';

    for (var j = 0; j < this.StaffProfileModel.QualificationArray.length; j++) {
      if (QualifivationID == '') {
        QualifivationID = this.StaffProfileModel.QualificationArray[j].ItemId;
      }
      else {
        QualifivationID = QualifivationID + "," + this.StaffProfileModel.QualificationArray[j].ItemId;
      }
    }

    this.StaffProfileModel.QualificationIDs = QualifivationID;
    this.SubmittedPersonnel = true;
    if (this.StaffProfileModel.EmploymentStatus == 'RESIGNED') {
      if (this.StaffProfileModel.DateOfLeaving == null || this.StaffProfileModel.DateOfLeaving == '') {
        this.LeavinDateMsg = 'Please select Date Of Leaving';
        return;
      }
    }
    if (valid && !this.ValidateDropdownPersonalDetails()) {
      this.StaffProfileModel.DateOfJoining = this.StaffProfileModel.DateOfJoining != null && this.StaffProfileModel.DateOfJoining != '' ? moment(this.StaffProfileModel.DateOfJoining).format('DD-MMM-YYYY') : '';
      this.StaffProfileModel.DateOfLeaving = this.StaffProfileModel.DateOfLeaving != null && this.StaffProfileModel.DateOfLeaving != '' ? moment(this.StaffProfileModel.DateOfLeaving).format('DD-MMM-YYYY') : '';
      this.spinnerService.show();
      this.staffservice.SaveStaffDetails(JSON.stringify(this.StaffProfileModel), '', '', '', '', 'PersonalDetails').subscribe((response: any) => {
        this.spinnerService.hide();
        this.SubmittedPersonnel = false;
        this.globalHelper.CheckActionStatus(response);
        this.SearchAllstaff();
      });
    }
  };

  EditStaffDependent(obj) {
    this.StaffProfileModel.StaffDependentID = obj.StaffDependentID;
    this.StaffProfileModel.DependentName = obj.DependentName;
    this.StaffProfileModel.RelationshipID = obj.RelationshipID;
    this.StaffProfileModel.StaffID = obj.StaffID;
    this.StaffProfileModel.DependentDOB = moment(obj.DOB).format('DD-MMM-YYYY');
    this.SubmittedDependent = false;
    this.Action = 'Edit'
  }
  ValidateDropdownDependent() {
    return this.StaffProfileModel.RelationshipID == 0;
  };


  SaveStaffDependentDetails(valid) {
    this.SubmittedDependent = true;

    if (valid && !this.ValidateDropdownDependent()) {
      this.StaffProfileModel.DependentDOB = this.StaffProfileModel.DependentDOB != null && this.StaffProfileModel.DependentDOB != '' ? moment(this.StaffProfileModel.DependentDOB).format('DD-MMM-YYYY') : '';
      this.spinnerService.show();
      this.staffservice.SaveStaffDetails(JSON.stringify(this.StaffProfileModel), '', '', '', '', 'StaffDependent').subscribe((response: any) => {
        this.SubmittedDependent = false;
        this.spinnerService.hide();
        this.GetStaffDependentDetails();
        this.globalHelper.CheckActionStatus(response);
      });
    }
  };

  GetStaffDependentDetails() {
    this.spinnerService.show();
    this.staffservice.GetStaffDependentDetails(this.StaffProfileModel.StaffID).subscribe((data: any) => {
      this.StaffDependentList = data.StaffDependentList;
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });

  }

  AddStaffChild(valid) {
    this.SubmittedChild = true;
    this.StudentExist = '';
    var ItemBO = {

      'ItemCode1': this.StaffProfileModel.StudentNo
    }
    if (valid) {
      this.spinnerService.show();
      this.lookupService.GetLookupsList('StudentID', JSON.stringify(ItemBO)).subscribe((data: any) => {
        this.AddChildList = data.LookupItems;
        this.MessageChild = '';
        if (this.AddChildList.length > 1) {
          this.SaveStaffChild(this.AddChildList[1].ItemId);
        }
        else {
          this.MessageChild = 'GR No. does not exist';

          this.SubmittedChild = false;
        }
        this.spinnerService.hide();
      });
    }
  };

  SaveStaffChild(item) {

    this.StaffProfileModel.StudentID = item;
    this.StudentExist = '';
    if (this.StaffChildList != null) {
      for (var i = 0; i < this.StaffChildList.length; i++) {
        if (this.StaffChildList[i].StudentID == this.StaffProfileModel.StudentID) {
          this.StudentExist = 'Student Already Mapped';
          return;
        }
      }
    }
    this.spinnerService.show();
    this.staffservice.SaveStaffDetails(JSON.stringify(this.StaffProfileModel), '', '', '', '', 'StaffChild').subscribe((response: any) => {
      this.GetStaffChildDetails();
      this.SubmittedChild = false;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });

  };

  RemoveStaffChild(item) {
    this.StaffProfileModel.StudentID = item.StudentID;
    this.StaffProfileModel.StaffID = item.StaffID;
    this.StaffProfileModel.StaffStudentRelationID = item.StaffStudentRelationID;
    this.spinnerService.show();
    this.staffservice.RemoveStaffChild(JSON.stringify(this.StaffProfileModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.GetStaffChildDetails();
    });

  }
  GetStaffChildDetails() {
    this.spinnerService.show();
    this.staffservice.GetStaffChildDetails(this.StaffProfileModel.StaffID).subscribe((data: any) => {
      this.StaffChildList = data.StaffChildList;
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });

  }

  // Staff Document

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };
  selectPhotoforUpload(file) {
    this.SelectPhotoforUpload = file[0];
  };

  FileAdd() {
    this.Docmsg = "";
    this.MesgAlert = "";
    if (this.SelectedFileForUpload == null) {
      this.Docmsg = 'Please Browser file';
      return;
    }
    if (this.DocsList != null) {
      for (var i = 0; i < this.DocsList.length; i++) {
        if (this.DocsList[i].DocumentID == this.StaffProfileModel.DocumentID) {
          this.Docmsg = 'Document is already exist';
          return;
        }
      }
    }

    var item = {
      DocumentID: this.StaffProfileModel.DocumentID,
      AdmissionDocumentName: this.GetDocumentName(this.StaffProfileModel.DocumentID),
      FileUpload: this.SelectedFileForUpload,
      FileName: this.SelectedFileForUpload.name
    };
    this.DocsList.push(item);
  };

  GetDocumentName(DocumentID) {
    if (this.StaffDocumentList != null) {
      for (var i = 0; i < this.StaffDocumentList.length; i++) {
        if (this.StaffDocumentList[i].ItemId == DocumentID) {
          return this.StaffDocumentList[i].ItemName;
        }
      }
    }
  }


  SaveDocument() {
    for (var i = 0; i < this.StaffDocumentList.length; i++) {
      var flag = false;
      for (var j = 0; j < this.DocsList.length; j++) {
        if (this.StaffDocumentList[i].ItemId == this.DocsList[j].DocumentID) {
          flag = true;
        }
      }
      if (this.StaffDocumentList[i].IsCompulsary && !flag) {
        this.MesgAlert = "please Upload  Mandatory Document"
        return;
      }
    }

    this.spinnerService.show();
    this.staffservice.SaveStaffDetails(JSON.stringify(this.StaffProfileModel), '', this.DocsList, this.SelectPhotoforUpload, '', 'Document').subscribe((response: any) => {
      this.spinnerService.hide();
      this.SearchAllstaff();
      this.globalHelper.CheckActionStatus(response);
    });
  }
  removeRowDoc(index) {
    this.DocsList.splice(index, 1);

  };
  GetStaffDocumentPhoto() {
    this.spinnerService.show();
    this.staffservice.GetStaffDocumentPhoto(this.StaffProfileModel.StaffID).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.DocsList = data.StaffDocumentPhotoList;
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();

    });

  }


  // Mark Active

  StaffMarkActive(obj) {
    this.StaffProfileModel.StaffID = obj.StaffID;
    this.StaffProfileModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.staffservice.StaffMarkActive(JSON.stringify(this.StaffProfileModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.SearchAllstaff();
      this.globalHelper.CheckActionStatus(data);


    });
  }
  // Paging
  Action = 'Add';
  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;

  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }
  // Init and Lookup
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.GetAllBank();
    this.GetDesignation();
    this.GetStaffDocument();
    this.GetDepartment();
    this.GetMaritalStatus();
    this.GetAllSchoolLocation();
    this.GetIDCardType();
    this.GetAllEmployeeCategory();
    this.GetAllEmployeeType();
    this.GetQulification();
    this.GetCountry();
    this.GetNationality();
    this.GetBloodGroup();
    this.GetRelationship();
    this.GetAllReligion();
  }

  GetAllBank() {
    this.lookupService.GetLookupsList('BankAll', '').subscribe((data: any) => {
      this.BankList = data.LookupItems;
    });

  }

  GetDesignation() {
    this.lookupService.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.Designation = data.LookupItems;
    });

  }


  GetStaffDocument() {
    this.lookupService.GetLookupsList('StaffDocument', '').subscribe((data: any) => {
      this.StaffDocumentList = data.LookupItems;
    });

  }

  GetDepartment() {
    this.lookupService.GetLookupsList('Department', '').subscribe((data: any) => {
      this.ListDepartment = data.LookupItems;
    });

  }

  GetMaritalStatus() {
    this.lookupService.GetLookupsList('MaritalStatus', '').subscribe((data: any) => {
      this.ListMarital = data.LookupItems;
    });

  }

  GetAllSchoolLocation() {
    this.lookupService.GetLookupsList('SchoolLocation', '').subscribe((data: any) => {
      this.SchoolLocationList = data.LookupItems;
    });

  }

  GetIDCardType() {
    this.lookupService.GetLookupsList('IDCardType', '').subscribe((data: any) => {
      this.IDCardTypeList = data.LookupItems;
    });

  }


  GetAllEmployeeCategory() {
    this.lookupService.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });

  }


  GetAllEmployeeType() {
    this.lookupService.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
      this.EmployeeTypeList = data.LookupItems;
    });

  }

  GetAllReligion() {
    this.lookupService.GetLookupsList('Religion', '').subscribe((data: any) => {
      this.ReligionList = data.LookupItems;
    });

  }

  GetReportingManager() {
    var ItemBO = {
      'ItemId1': this.StaffProfileModel.StaffID
    }
    this.lookupService.GetLookupsList('ReportingManager', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ReportingManagerList = data.LookupItems;
    });

  }

  GetQulification() {

    this.lookupService.GetLookupsList('StaffQualification', '').subscribe((data: any) => {
      this.QualificationList = data.LookupItems;
      this.QualificationList.splice(0, 1);
    });
  };
  GetPresentState() {
    var ItemBO = {
      ItemId: this.StaffProfileModel.PresentCountryID
    }
    this.lookupService.GetLookupsList('State', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.StateList = data.LookupItems;
    });
  };

  GetCityName() {
    var itembo = {
      'ItemID': this.StaffProfileModel.PresentStateID,
    }
    this.lookupService.GetLookupsList('City', JSON.stringify(itembo)).subscribe((data: any) => {
      this.City = data.LookupItems;
    });
  };
  GetCountry() {

    this.lookupService.GetLookupsList('Country', '').subscribe((data: any) => {
      this.CountryList = data.LookupItems;
    });
  };

  GetBloodGroup() {

    this.lookupService.GetLookupsList('BloodGroup', '').subscribe((data: any) => {
      this.BloodGroupList = data.LookupItems;
    });
  };

  GetRelationship() {

    this.lookupService.GetLookupsList('Relationship', '').subscribe((data: any) => {
      this.RelationShipList = data.LookupItems;
    });
  };

  GetNationality() {

    this.lookupService.GetLookupsList('Nationality', '').subscribe((data: any) => {
      this.NationalityList = data.LookupItems;
    });
  };


  // Download

  GetDownloadStaff() {

    this.searchStaffModel.CurrentIndex = 0;
    this.searchStaffModel.PageSize = 0;
    this.spinnerService.show();
    this.staffservice.GetDownloadStaff(JSON.stringify(this.searchStaffModel)).subscribe((response: any) => {
      this.FilePath = response.FilePath;
      window.location = response.FilePath;
      this.spinnerService.hide();

    });
  };

// jjhjh
PrintButton = true;
  IsSelect = false
    SelectAll() {
        if (this.IsSelect) {
            for (var i = 0; i < this.ListStaff.length; i++) {
                this.ListStaff[i].IsActive1 = true;
                this.PrintButton = false;
            }
        }
        if (this.IsSelect == false) {
            for (var i = 0; i < this.ListStaff.length; i++) {
                this.ListStaff[i].IsActive1 = false;
                this.PrintButton = true;
            }
        }
    }
    Count1 = 0;
    ChangeSelect(item) {
        this.Count1 = 0;
        for (var i = 0; i < this.ListStaff.length; i++) {
            if (this.ListStaff[i].IsActive1) {
                this.Count1 = this.Count1 + 1
                this.PrintButton = false;
            }
        }
        if (this.Count1 == this.ListStaff.length) {
            this.IsSelect = true;
            this.PrintButton = false;
        }
        else {
            this.IsSelect = false;
        }

    }

  // Print
 
    AllPrint() {
        
        var objStaff = '';
        

        for (var i = 0; i < this.ListStaff.length; i++) {
            if (this.ListStaff[i].IsActive1) {
              objStaff = objStaff == '' ? this.ListStaff[i].StaffID : objStaff + ',' + this.ListStaff[i].StaffID;
             
            }
        }

       
       
        var url = "printstaffidcard?StaffIDs=" + objStaff  ;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

    }
  printdetails(item) {
    var url = "printidcard?SatffID=" + item.SatffID ;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");    
}

// printbulkidcard() {
//     var url = "printidcard?ClassID=" + this.SearchFilter.ClassID + "&SectionID=" + this.SearchFilter.SectionID+ "&StudentID=" + this.SearchFilter.StudentID;
//     this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    
// }

}
